<template>
  <ol class="list-none pl-0 relative">
    <li v-for="(item, index) in items" :key="index" class="mb-3 relative">
      <div
        v-if="index < items.length - 1"
        class="absolute left-3 top-5 -bottom-3 w-0.5"
        :style="{
          backgroundColor: item.lineColor || '#e5e7eb'
        }"
      ></div>

      <div class="flex items-start">
        <div class="mr-3 shrink-0">
          <div
            class="w-6 h-6 rounded-full flex items-center justify-center relative z-10"
            :style="{
              backgroundColor: item.circleFill || '#e5e7eb',
              border: `2px solid ${item.circleBorder || 'transparent'}`
            }"
            style="left: 1px"
          >
            <slot name="icon" :item="item">
              <svg
                class="w-3 h-3"
                :style="{
                  color: item.iconColor || '#6b7280',
                  opacity: item.grey ? 0.4 : 1
                }"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill="currentColor"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                />
              </svg>
            </slot>
          </div>
        </div>

        <div class="flex-1">
          <!-- Apply grey text when item.grey is true -->
          <div>
            <slot name="item" :item="item">
              <div class="flex items-center justify-between mb-1">
                <h3
                  class="text-lg font-semibold"
                  :class="{
                    'text-gray-900 dark:text-white': !item.grey,
                    'text-gray-400 dark:text-gray-500': item.grey
                  }"
                >
                  {{ item.title }}
                </h3>
                <span
                  v-if="item.isLatest"
                  class="bg-blue-100 text-blue-800 text-sm font-medium px-2.5 py-0.5 rounded-full dark:bg-blue-900 dark:text-blue-300"
                >
                  {{ item.isLatest }}
                </span>
              </div>
              <time
                class="block text-sm"
                :class="{
                  'text-gray-500 dark:text-gray-400': !item.grey,
                  'text-gray-400 dark:text-gray-500': item.grey
                }"
              >
                {{ item.date }}
              </time>
              <p
                class="text-base font-normal"
                :class="{
                  'text-gray-700 dark:text-gray-300': !item.grey,
                  'text-gray-400 dark:text-gray-500': item.grey
                }"
              >
                {{ item.description }}
              </p>
              <a
                v-if="item.downloadUrl"
                :href="item.downloadUrl"
                class="inline-flex items-center mt-3 text-blue-600 hover:text-blue-800 dark:text-blue-500"
              >
                <svg
                  class="w-4 h-4 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                Download ZIP
              </a>
            </slot>
          </div>
        </div>
      </div>
    </li>
  </ol>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
    default: () => []
  }
});
</script>
